import type { EntityBaseFields } from '@tundr/http';

export enum WelfarePlan {
  STANDARD = 'STANDARD',
  COMPLETE = 'COMPLETE',
}

export type CompanyChannel = {
  id: string;
  assetCode: string;
  name: string;
};

export type LoginUser = EntityBaseFields & {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  birthdate: string;
  deletedAt: string | null;
  enabled: boolean;
  externalId: string;
  privacyAcceptanceDate: string;
  termsAcceptanceDate: string;
};

export type LoginCompany = {
  id: string;
  name: string;
  currentWelfarePlan: WelfarePlan;
  companyChannel: CompanyChannel;
  email: string;
  hrId: string;
  hasMealVoucher?: boolean;
};

export type AuthData = {
  user: LoginUser;
  permissions?: string[];
  companies: LoginCompany[];
};
